import React from 'react'
import walgreen from "../../assets/images/walgreen.png"
import walmart from "../../assets/images/walmart.png"
import gnc from "../../assets/images/gnc.png"
import gvs from "../../assets/images/gvs.png"
import checkmark from "../../assets/images/check-mark 1.png"



const BrandingLogo = () => {
  return (
    <div className="mt-6 px-6">
            <div className="max-w-5xl mx-auto">
              <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8 mb-2">
                <div className="flex items-center">
                  <div className="w-32 h-12 flex items-center justify-center">
                    <img
                      src={walgreen}
                      alt="Walgreens Logo"
                      className="h-8 object-contain transition-transform duration-300 ease-in-out hover:scale-110"
                    />
                  </div>
                </div>

                <div className="flex items-center">
                  <div className="w-32 h-12 flex items-center justify-center">
                    <img
                      src={walmart}
                      alt="Walmart Logo"
                      className="h-8 object-contain transition-transform duration-300 ease-in-out hover:scale-110"
                    />
                  </div>
                </div>

                <div className="flex items-center">
                  <div className="w-24 h-12 flex items-center justify-center">
                    <img
                      src={gnc}
                      alt="GNC Logo"
                      className="h-8 object-contain transition-transform duration-300 ease-in-out hover:scale-110"
                    />
                  </div>
                </div>

                <div className="flex items-center">
                  <div className="w-24 h-12 flex items-center justify-center">
                    <img
                      src={gvs}
                      alt="CVS Logo"
                      className="h-8 object-contain transition-transform duration-300 ease-in-out hover:scale-110"
                    />
                  </div>
                </div>

                <div className="flex items-center">
                  <div className="flex items-center">
                    <div className="flex items-center justify-center">
                      <img
                        src={checkmark}
                        alt="CVS Logo"
                        className="h-10 object-contain"
                      />
                    </div>
                  </div>
                  <div className="ml-2 leading-[24px]">
                    <p className="font-bold text-[20px] bold-font">
                      Only Available
                    </p>
                    <p className="font-bold text-[20px] bold-font">
                      On This Page!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

  )
}

export default BrandingLogo